module.exports = __webpack_public_path__ + "static/media/ar.9324a7ae.svg";